/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Notificationservicehuburl3Inputs */

const en_entity_notificationservicehuburl3 = /** @type {(inputs: Entity_Notificationservicehuburl3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification Service Hub URL`)
};

const de_entity_notificationservicehuburl3 = /** @type {(inputs: Entity_Notificationservicehuburl3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungsservice Hub URL`)
};

/**
* | output |
* | --- |
* | "Notification Service Hub URL" |
*
* @param {Entity_Notificationservicehuburl3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_notificationservicehuburl3 = /** @type {((inputs?: Entity_Notificationservicehuburl3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Notificationservicehuburl3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_notificationservicehuburl3(inputs)
	return de_entity_notificationservicehuburl3(inputs)
});
export { entity_notificationservicehuburl3 as "entity_notificationServiceHubUrl" }